module.exports = __webpack_public_path__ + "img/my-account.a9b3cfdd.svg";